import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import { Minimatch } from 'minimatch';
import { useCookieStore } from '~/stores/cookie';

// Scroll down for configuration

function getMatchingPixel(options, path) {
  return options.pixels.find(function (pixel) {
    var routeIndex = pixel.routes.findIndex(function (route) {
      var minimatch = new Minimatch(route);
      return minimatch.match(path);
    });
    return routeIndex !== -1;
  });
}
function generateEventId() {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var len = possible.length;
  for (var i = 0; i < 11; i++) {
    text += possible.charAt(Math.floor(Math.random() * len));
  }
  return [text, new Date() - 0].join('-');
}
function log() {
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  console.info.apply(this, ['[client/plugins/pixel]'].concat(messages));
}
var FbTracker = /*#__PURE__*/function () {
  function FbTracker(fbq, options, $axios) {
    _classCallCheck(this, FbTracker);
    this.options = options;
    this.fbq = fbq;
    this.$axios = $axios;
    this.isEnabled = !options.disabled;
  }
  return _createClass(FbTracker, [{
    key: "setPixelId",
    value: function setPixelId(id) {
      this.options.pixelId = id;
      this.init();
    }
  }, {
    key: "enable",
    value: function enable() {
      this.isEnabled = true;
      this.init();
      this.trackSingle();
    }
  }, {
    key: "disable",
    value: function disable() {
      this.isEnabled = false;
    }
  }, {
    key: "init",
    value: function init() {
      this.query('init', this.options.pixelId);
    }
  }, {
    key: "consent",
    value: function consent(enable) {
      this.fbq('consent', enable ? 'grant' : 'revoke');
    }
  }, {
    key: "track",
    value: function track() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var eventData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!event) event = this.options.track;
      this.query({
        cmd: 'track',
        option: event,
        parameters: parameters,
        eventData: eventData
      });
    }
  }, {
    key: "trackSingle",
    value: function trackSingle() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var eventData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!event) event = this.options.track;
      this.query({
        cmd: 'trackSingle',
        option: event,
        pixelId: this.options.pixelId,
        parameters: parameters,
        eventData: eventData
      });
    }
  }, {
    key: "query",
    value: function query(_ref) {
      var cmd = _ref.cmd,
        option = _ref.option,
        _ref$pixelId = _ref.pixelId,
        pixelId = _ref$pixelId === void 0 ? null : _ref$pixelId,
        _ref$parameters = _ref.parameters,
        parameters = _ref$parameters === void 0 ? {} : _ref$parameters,
        _ref$eventData = _ref.eventData,
        eventData = _ref$eventData === void 0 ? {} : _ref$eventData;
      if (!eventData.eventID) eventData.eventID = generateEventId();
      if (this.options.debug) log('Command:', cmd, 'Option:', option, 'pixelId:', pixelId, 'Parameters:', parameters, 'Event data:', eventData);
      if (!this.isEnabled) return;
      var params = {
        option: option,
        pixelId: this.options.pixelId,
        parameters: parameters,
        eventId: eventData.eventID,
        sourceUrl: window.location.href
      };
      if (pixelId) {
        this.fbq(cmd, pixelId, option, parameters, eventData);
        params.pixelId = pixelId;
      } else {
        this.fbq(cmd, option, parameters, eventData);
      }
      this.$axios.$post("".concat(this.$axios.defaults.baseURL, "/facebookconversion/event"), params, {
        progress: false
      }).catch(function (e) {
        console.log(e);
      });
    }
  }]);
}(); // Init
export default function (context, inject) {
  var autoPageView = true;
  var manualMode = true;
  var disabled = process.env.NODE_ENV != 'production';
  var debug = process.env.NODE_ENV != 'production';
  var cookieStore = useCookieStore();

  // Configuration
  var configOptions = {
    track: 'PageView',
    pixelId: '2736883069917156',
    autoPageView: autoPageView,
    manualMode: manualMode,
    disabled: disabled,
    debug: debug,
    pixels: [{
      track: 'PageView',
      pixelId: '776422326509060',
      autoPageView: autoPageView,
      manualMode: manualMode,
      disabled: disabled,
      debug: debug,
      routes: ['/learning', '/learning/', '/learning/**']
    }]
  };

  // Default options
  var DEFAULT_OPTIONS = {
    pixelId: null,
    track: 'PageView',
    autoPageView: false,
    version: '2.0',
    pixels: [],
    manualMode: false,
    disabled: false,
    debug: false
  };

  // Parse options
  var options = Object.assign({}, DEFAULT_OPTIONS, configOptions);
  if (options.pixels && options.pixels.length > 0) {
    options.pixels = options.pixels.map(function (option) {
      return Object.assign({}, DEFAULT_OPTIONS, option);
    });
  }

  // No pixel ID present, skip
  if (!options.pixelId) return;
  var _fbq;
  var isDev = options.dev && !options.debug;
  var path = context.route.path;
  var matchingPixel = getMatchingPixel(options, path);
  var pixelOptions = Object.assign({}, matchingPixel || options);
  if (typeof window !== 'undefined') {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = pixelOptions.version;
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.defer = true;
      t.src = v;
      s = b.getElementsByTagName('body')[0];
      s.parentNode.appendChild(t, s);
      _fbq = fbq;
      fbq('consent', cookieStore.getCookieConsent.marketing ? 'grant' : 'revoke');
      if (!isDev && !pixelOptions.disabled) {
        if (pixelOptions.manualMode) {
          fbq('set', 'autoConfig', false, pixelOptions.pixelId);
        }

        // This is a HACK to get facebook pixel to track PageViews with our custom event IDs
        // See: https://stackoverflow.com/questions/68475242/facebook-pixel-with-conversion-api-help-tracking-same-event-ids
        fbq.disablePushState = true;
        fbq.allowDuplicatePageViews = true;
        // TODO: when this breaks, use VirutalPageView instead:
        // https://support.qualifio.com/hc/en-us/articles/360025887334-Use-virtual-pageviews-with-Facebook-Pixel-code

        fbq('init', pixelOptions.pixelId);
        // Initial PageView is tracked by router.afterEach
        // fbq('track', pixelOptions.track);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }
  var instance = new FbTracker(_fbq, pixelOptions, context.$axios);
  if (context.app && context.app.router) {
    var router = context.app.router;
    router.afterEach(function (_ref2) {
      var path = _ref2.path;
      var matchingPixel = getMatchingPixel(options, path);
      var pixelOptions = Object.assign({}, matchingPixel || options);
      if (pixelOptions.pixelId !== instance.options.pixelId) {
        instance.setPixelId(pixelOptions.pixelId);
      }
      if (options.autoPageView) {
        // See: https://developers.facebook.com/docs/marketing-api/conversions-api/deduplicate-pixel-and-server-events
        instance.trackSingle('PageView');
      }
    });
  }
  inject('fbPixel', instance);
  context.$fbPixel = instance;
}